/**
 * Caption pronoun for a fixture: "his team's first goal" / "her" / "their".
 *
 * Client mirror of `Match.derive_subject_pronoun` in
 * src/operator/registry/models.py, which is the SOURCE OF TRUTH. The regex is
 * `Team._WOMENS_MARKER` copied verbatim; change it there first, then here.
 *
 * The server also reads each team's POOL ROOT name, which the team payload
 * does not carry, so this mirror only pre-fills the wizard's dropdown. An
 * untouched dropdown sends nothing on create and the server derives the
 * stored value itself; only an explicit choice goes on the wire.
 */

export const DEFAULT_SUBJECT_PRONOUN = 'his';

export const SUBJECT_PRONOUNS = [
  { value: 'his', label: 'his' },
  { value: 'her', label: 'her' },
  { value: 'their', label: 'their' },
];

// Team._WOMENS_MARKER, verbatim (Python re.IGNORECASE == JS /i).
const WOMENS_MARKER = /\b(vrouwen|frauen|women|woman|dames|ladies|feminin\w*|femenino|v\d)\b/i;

/** Team._is_womens_name */
export function isWomensName(name) {
  return WOMENS_MARKER.test(name || '');
}

/**
 * The pronoun a fixture's team names imply: 'her' when any name carries the
 * women's marker, else the 'his' default. Missing names count as no marker.
 */
export function deriveSubjectPronoun(...teamNames) {
  return teamNames.some(isWomensName) ? 'her' : DEFAULT_SUBJECT_PRONOUN;
}
